
/** @module TS.MessageBox */

TS.MessageBox = TS.MessageBox || {};

(function() {
    'use strict';

    function buildMessageBody(items) {
        var wrapFunc = function(item) {
            return '<li>' + item + '</li>';
        };
        var ret = items.map(wrapFunc);
        ret = '<ul>' + ret + '</ul>';
        return ret;
    }
	
    var messageBoxButtons = {
    	OK: { buttons: ['OK'], default: 'OK', escape: 'OK' },
    	OKCancel: { buttons: ['OK', 'Cancel'], default: 'OK', escape: 'Cancel' },
    	AbortRetryIgnore: { buttons: ['Abort', 'Retry', 'Ignore'], default: 'Abort', escape: 'Abort' },
    	YesNoCancel: { buttons: ['Yes', 'No', 'Cancel'], default: 'Yes', escape: 'Cancel' },
    	YesNo: { buttons: ['Yes', 'No'], default: 'Yes', escape: 'No' },
    	RetryCancel: { buttons: ['Retry', 'Cancel'], default: 'Retry', escape: 'Cancel' }
    };

    $.extend(TS.MessageBox, {
    	Buttons: {
    		get OK() { return 'OK'; },
    		get OKCancel() { return 'OKCancel'; },
    		get AbortRetryIgnore() { return 'AbortRetryIgnore'; },
    		get YesNoCancel() { return 'YesNoCancel'; },
    		get YesNo() { return 'YesNo'; },
    		get RetryCancel() { return 'RetryCancel'; }
    	},

    	Icons :{
    		get None() { return 'None'; },
    		get Error() { return 'Error'; },
    		get Hand() { return 'Hand'; },
    		get Stop() { return 'Stop'; },
    		get Question() { return 'Question'; },
    		get Exclamation() { return 'Exclamation'; },
    		get Warning() { return 'Warning'; },
    		get Information() { return 'Information'; },
    		get Asterisk() { return 'Asterisk'; }
    	},
		
    	show: function (args) {
    		var culture = TS.cultures.current,
				message = args.message;
    		if (TS.isArray(message)) {
    			message = buildMessageBody(message);
    		}
    		var createCallback = 
				function (button) {
					if (args.callback) {
						return function () {
							args.callback(button);
						}
					}
    				return $.noop;
    			},
				msgButtons = messageBoxButtons[args.buttons],
				options = {
    				message: message,
    				title: args.caption,
    				animate: false,
    				backdrop: 'static', // 'static' instead of true; does not dismiss the dialog when clicking outside
    				onEscape: createCallback(msgButtons.escape),
    				buttons: {}
				};
    		if (args.defaultButton !== null && typeof args.defaultButton !== 'undefined') {
    			args.defaultButton = msgButtons.buttons[args.defaultButton];
    		}

    		msgButtons.buttons.forEach(function (button) {
    			options.buttons[button] = {
    				label: culture.messageBox.buttons[button],
    				className: (args.defaultButton || msgButtons.default) === button ? "btn-primary" : "btn-default",
    				callback: createCallback(button)
    			};
    		});
    		bootbox.dialog(options);
    	}
    });

})();
